import Vue from 'vue'
import { Message, Cascader } from 'element-ui'
import xcUi from './xc-ui'

import App from './App.vue'
import router from './router'
import store from './store/index'
import http from './utils/http'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './scss/common.scss';

Vue.use(ElementUI);

Vue.use(xcUi);
Vue.use(Cascader);

Vue.prototype.$config = {
    ...process.env,
    adminPath: process.env.VUE_APP_ADMIN_PATH,
};
Vue.prototype.$http = http;
Vue.prototype.$message = Message;

Vue.config.productionTip = false

new Vue({
    router,
    store,
    el: '#app',
    render: h => h(App)
}).$mount('#app')
